import React from 'react'
import type { CompanySelectProps } from '@ztechapps/webui.contract'
import { SelectOptionCell, SelectOptionColumn } from '@ztechapps/webui.input'
import { SelectAsyncCreatable } from '@ztechapps/webui.input'
import { gql } from '@apollo/client'
import type { GroupBase, MenuListProps } from 'react-select'
import { components } from 'react-select'
import { Row } from 'react-bootstrap'
import { ShowIf } from '@ztechapps/webui.util'
import { StatusEnum } from '@ztechapps/common.contract'

const companyQuery = gql`
  query allCompany($filter: JSON!, $options: JSON) {
    allCompany(filter: $filter, options: $options) {
      _id
      name
      domain
    }
  }
`

const companyWithUsersQuery = gql`
  query companyList($filter: JSON!, $options: JSON) {
    companyList(filter: $filter, options: $options) {
      _id
      name
      domain
    }
  }
`

const dataLoadOptions = ({ filter, withUsersOnly }: any = {}) => {
  return {
    query: withUsersOnly ? companyWithUsersQuery : companyQuery,
    filter: ({ input }: any) => ({
      status: StatusEnum.Active,
      name: {
        $nin: ['', null],
      },
      $or: [{ name: { $regex: input, $options: 'i' } }],
      ...(withUsersOnly ? { contactCount: { $gt: 0 } } : {}),
      ...filter,
    }),
    resultFieldName: withUsersOnly ? 'companyList' : 'allCompany',
  }
}
export const CompanyMenuList = <Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  props: MenuListProps<Option, IsMulti, Group>
) => {
  const { children, ...rest } = props
  return (
    <components.MenuList {...rest} className="m-0 p-0">
      <Row className="m-0 bg-secondary-subtle fw-bold sticky-top ">
        <SelectOptionColumn>Company Name</SelectOptionColumn>
        <SelectOptionColumn>Domain Name</SelectOptionColumn>
      </Row>
      {children}
    </components.MenuList>
  )
}

export const CompanyOptionSimple = ({ data, ...rest }: any) => {
  //always set the isSelected to false so it wont highlight
  const companyName = data?.name ?? ''
  const domainName = data?.domain ?? ''
  return (
    <components.Option {...{ ...rest, data, isSelected: false }} className="m-0 p-0">
      <ShowIf condition={data?.__isCreate}>
        <SelectOptionColumn>{companyName}</SelectOptionColumn>
      </ShowIf>
      <ShowIf condition={!data?.__isCreate}>
        <Row className="m-0">
          <SelectOptionColumn className="small ">{companyName}</SelectOptionColumn>
          <SelectOptionCell value={domainName} className="small " icon="envelope" />
        </Row>
      </ShowIf>
    </components.Option>
  )
}

export const CompanySelect = ({ filter, withUsersOnly = false, ...rest }: CompanySelectProps) => {
  return (
    <SelectAsyncCreatable
      {...{
        components: { Option: CompanyOptionSimple, MenuList: CompanyMenuList },

        dataLoadOptions: dataLoadOptions({ filter, withUsersOnly }),
        placeholder: 'Type company name',
        labelKey: 'name',
        getNewOptionData: (inputValue, optionLabel) => {
          return {
            value: inputValue,
            label: inputValue,
            name: optionLabel,
            _id: null, //if create we set this to null
            __isCreate: true,
          }
        },
        ...rest,
      }}
    />
  )
}
